export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 flex flex-col items-start gap-5 w-full">
            <div className="flex items-center gap-2">
              <span className="inline-block px-3 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                今日吃瓜入口
              </span>
              <span className="inline-block px-3 py-1.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                每日更新
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
              在线吃瓜 · 热点聚合第一站
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              51在线吃瓜今日吃瓜入口，每日聚合全网最新爆料和今日热点。覆盖明星八卦、综艺名场面、网红翻车、热播剧吐槽等热门领域，从吃瓜前线到深度扒皮，以图文和今日吃瓜视频多维度呈现。坚持真实客观、理性吃瓜的理念，做你身边的每日吃瓜好伙伴。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">每日更新 200+ 条热点</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">覆盖 12 大热门领域</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">7×24 小时不间断</span>
              </div>
            </div>

            <div className="flex items-center gap-3 pt-2">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
                <i className="ri-arrow-right-line text-base"></i>
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                最新快讯
                <i className="ri-flashlight-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20entertainment%20gossip%20news%20aggregation%20abstract%20art%20with%20warm%20coral%20and%20cream%20gradient%2C%20newspaper%20and%20megaphone%20silhouette%20motifs%2C%20soft%20modern%20editorial%20design%2C%20minimal%20clean%20composition%2C%20elegant%20aesthetic%2C%20harmonious%20warm%20color%20palette%2C%20no%20text&width=960&height=720&seq=hero-main&orientation=landscape"
                alt="在线吃瓜今日热点聚合平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}